// export const SOCKET_BASE_URL: string = `https://cisia.netseven.it:6111`;
//export const SOCKET_BASE_URL: string = `https://clitolc.cisiaonline.it`;
export const SOCKET_BASE_URL: string = `https://4.clitolc.cisiaonline.it`;
export const FEEDBACK_URL: string = `http://allenamento.cisiaonline.it/utenti_esterni/form_client_segnalazioni.php`;
export const QUESTIONARIO_URL: string = `http://allenamento.cisiaonline.it/utenti_esterni/form_client_impressioni.php`;
export const USE_MOCK: boolean = false;
export const DEBUG: boolean = false;

export const EXTERNAL_URL_TO_CHECK_CONNECTION: string = 'https://cdnjs.cloudflare.com/ajax/libs/normalize/7.0.0/normalize.min.css';
export const EXTERNAL_URL_TO_CHECK_CONNECTION_TIMEOUT: number = 10000;
export const CISIA_URL_TO_CHECK_CONNECTION: string = 'https://cdnjs.cloudflare.com/ajax/libs/normalize/7.0.0/normalize.min.css';
export const CISIA_URL_FOR_CONNECTION_SPEED: string = 'https://webapp.cisiaonline.it/img_big_size.jpg';
export const CISIA_CONSOLE_COMBINATION: Array<number> = [68, 73, 65, 71, 78, 79, 83, 73 ]; // == DIAGNOSI
//export const CISIA_CONSOLE_COMBINATION: Array<number> = [67, 73, 83, 73, 65, 79, 78]; // == cisiaon
export const PARTS_TO_CHECK = {
  server: true,
  internet: true,
  canvas: true,
  html5: true,
  audio: true,
  storage: true,
  websockets: true,
  speedTest: true,
  // sendLog: true
};

export const ANSWER_SUBST_TEMPLATE_0 = '____X._____';
export const ANSWER_SUBST_TEMPLATE_1 = '_____[X]_____';
export const ANSWER_SUBST_REGEXPR_0 = new RegExp('____[0-9]+\._____', 'g');
export const ANSWER_SUBST_REGEXPR_1 = new RegExp('\{\{[0-9]+\}\}', 'g');

export const PING_INTERVAL: number = 15000;
export const WAITING_BEFORE_START: number = 60;
export const TIMEOUT_IDLE_LOGIN: number = 600000;
export const WELCOME_PAGE = 'index.php';

export const SHOW_FEEDBACK_BUTTON: boolean = false;
export const DEFAULT_PROFILE_PICTURE = 'assets/img/avatar.png';

export const SHOW_TITLE_IN_UNDERSTANDING_TEXT: boolean = false;
export const TIMEOUT_REQUEST_SECS: number = 60;
export const TIMEOUT_REQUEST_SECS_IN_MULTIPLE_REQ_MODE: number = 600;
export const FAKE_LOGIN_DELAY_MS: number = 2000;
export const ALERT_AUTOCLOSE_MS: number = 4500;
export const TRY_AGAIN_N: number = 1;
export const MULTIPLE_REQUESTS: boolean = true;
export const SYNC_ON_INTERRUPT_ATTEMP: boolean = false;
export const SYNC_DURING_TEST: boolean = true;
export const SYNC_FREQUENCY_SECS: number = 300;

export const FREE_INSERT_MODE: boolean = false;
export const TRAINING_MODE: boolean = false;
export const SHOW_BACK_TO_REVIEW_IN_REGULAR_MODE: boolean = false;
export const SHOW_ONLY_WRONG_AND_EMPTY_RESULTS: boolean = true;
export const USE_WATERMARK: boolean = true;
export const CHECK_BEFORE_CLOSE: boolean = true;
export const REQUEST_FULLSCREEN: boolean = true;

export const SHOW_PULSE: boolean = true;
export const COUNT_DOWN_AT_FULLSCREEN_EXIT: boolean = true;
export const NUMBER_OF_EXIT_ALLOWED: number = 4;

export const FULLSCREEN_EXIT_ON_LOST_FOCUS: boolean = true;
export const FULLSCREEN_EXIT_IN_SECS: number = 2;

export const FULLSCREEN_EXIT_ON_MOUSE_OUT: boolean = true;
export const MOUSE_OUT_ALLOWED_SECS: number = 5;
export const MOUSE_OUT_ALLOWED_WIHOUT_PULSE_SECS: number = 3;

export const FULLSCREEN_EXIT_ON_RESIZE: boolean = false;
export const RESIZE_TOLERANCE_IN_PX: number = 150;

export const TERMINATE_OUT_OF_FULLSCREEN_IN_SECS: number = 10;

export const DISABLE_RIGHT_CLICK: boolean = true;
export const DISABLE_SHORTCUT: boolean = true;
export const DISABLE_CONSOLE: boolean = true;
export const DISABLE_SELECTION: boolean = true;

export const CHECK_DEV_TOOLS: boolean = true;
export const INTERACTIVE_LABEL: boolean = true;

export const NOTIFY_CONNECTION_STATUS_WITH_GROWL: boolean = false;
export const NOTIFY_REQUEST: boolean = false;

export const USER_INIT_USERNAME: string = '';
export const USER_INIT_PASSWORD: string = '';

export const RND_SECTION_LOAD_SAFETY_SPAN = 180;
export const RND_SECTION_LOAD_FIRST_MAX_DELAY = 10;
export const RND_SECTION_LOAD_NTH_MAX_DELAY = 120;

export const TIME_BEFORE_REDIRECT_DUPLICATE_LOGIN: number = 10000;
export const TIMEOUT_NEW_SECTION_LOADING: number = 300; // secs

export const RECURSIVE_TIME_B_HANDLING: number = 375; // 375|753



// WEBPACK FOOTER //
// ./src/app/constants/configs/tolc.ts